module.exports = __webpack_public_path__ + "images/emoji/tram.02087328445bf73795d0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tram.png
// module id = fQgZ
// module chunks = 14